import { Component } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Capacitor } from "@capacitor/core";

@Component({
  selector: "app-force-update",
  templateUrl: "./force-update.component.html",
  styleUrl: "./force-update.component.scss",
})
export class ForceUpdatePage {
  constructor(private platform: Platform) {}

  goToStore() {
    const isIos = Capacitor.getPlatform() === "ios";
    const url = isIos
      ? "https://apps.apple.com/app/idYOUR_APP_ID"
      : "https://play.google.com/store/apps/details?id=com.rc.connect";
    window.open(url, "_system");
  }
}
